import { render, staticRenderFns } from "./DomainError.vue?vue&type=template&id=493034ff&scoped=true"
import script from "./DomainError.vue?vue&type=script&lang=js"
export * from "./DomainError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493034ff",
  null
  
)

export default component.exports